export const authTypes = {
    LOGIN: 'auth/LOGIN',
    LOGOUT: 'auth/LOGOUT',
};

const initialState = {
    authenticated: localStorage.getItem('token') ? true : false,
    user: localStorage.getItem('user')
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case authTypes.LOGIN:
            const { user } = payload;
            return { ...state, user, authenticated: true };

        case authTypes.LOGOUT:
            localStorage.clear();
            return { ...state, authenticated: false };

        default:
            return state
    }
};

export function login(user) {
    return { type: authTypes.LOGIN, payload: { user } };
}

export function logout() {
    return { type: authTypes.LOGOUT };
}
